/**
 * DOM ids that guided tours target.
 *
 * These are a contract, not decoration. useTabJoyride's target_not_found
 * recovery chain branches on them to work out what the user actually did —
 * whether the vehicle wizard opened, whether they resumed a saved draft
 * straight into the form, whether a message box appeared — and silently
 * mis-recovers if one is renamed. Nothing in the markup said so: they were
 * ordinary `id="…"` strings in six components, and the only place that knew
 * they mattered was a chain of string comparisons in another file.
 *
 * Import from here at BOTH ends. Renaming an anchor is then a single edit that
 * moves the tour with it, and grep for the constant shows every party to the
 * contract.
 *
 * Anchors used only as ordinary step targets (the many `#thid-*` column headers,
 * dashboard cards, sub-menu buttons) are not listed — they are read from the
 * step definitions themselves, so a rename shows up as a skipped step rather
 * than as a wrong branch. It is specifically the ones the recovery logic
 * *inspects* that need naming.
 */
export const TOUR_ANCHORS = Object.freeze({
    // Inventory sheet: the "Add New" button the inventory tour falls back to
    // when the sheet has no rows to click.
    inventoryAddNew: 'inventory-add-new',

    // The origin picker / spec wizard, and its "enter manually" escape hatch.
    vehiclePickerModal: 'vehicle-picker-modal',
    vehiclePickerEnterManually: 'vehicle-picker-enter-manually',

    // The vehicle form itself — reached either through the wizard or directly
    // when the user resumes a saved draft. Rendered by both AddEditInventory
    // and AddEditCommitted.
    carDetailsModal: 'car-details-modal',

    // The app's confirm/prompt dialog. The tour waits on it to decide whether
    // the user answered the "choose an origin" prompt.
    messageBox: 'message-box',

    // Hands off from the sales tour to the messaging tour.
    startMessagingTourButton: 'start-messaging-tour-button',
});

//`#id` form, for step targets and querySelector.
export const anchor = (key) => `#${TOUR_ANCHORS[key]}`;
